import { NgModule } from '@angular/core';
import { TableRefreshComponent } from './table-refresh.component';
import { CommonModule } from '@angular/common';
import { IconModule } from 'src/app/components/icon/icon.module';

@NgModule({
  declarations: [TableRefreshComponent],
  imports: [CommonModule, IconModule],
  exports: [TableRefreshComponent],
})
export class TableRefreshModule {}
